import { Box, Container, Divider, Typography } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import moment from "moment-timezone";
import BusinessDisplay from "../../../common/components/data-display/BusinessDisplay";
import { ProductInstanceSummary } from "../../../common/components/product/ProductInstanceSummary";
import ProductQuantityChip from "../../../common/components/product/ProductQuantityChip";
import { displayPrice } from "../../../common/util/DisplayUtil";
import { usePresaleOrderContext } from "./PresaleOrderFormContext";

export default function PresaleOrderDetails() {
  const { presaleOrder } = usePresaleOrderContext();

  return (
    <Container sx={{ mt: 1 }}>
      {presaleOrder && (
        <Grid container spacing={2}>
          <Grid xs={12} sm={5}>
            <Box sx={{ display: "flex", gap: 2, flexDirection: "column" }}>
              <Typography variant="h4">Market Sale Order Details</Typography>
              <Typography variant="subtitle1">
                Order ID: MS{presaleOrder.id}
              </Typography>
              <Divider />
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Typography variant="h6">Buyer: </Typography>
                <BusinessDisplay business={presaleOrder.buyerBusiness} />
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Typography variant="h6">Order Placed: </Typography>
                <Typography variant="body1">
                  {presaleOrder.confirmedDate
                    ? moment(presaleOrder.confirmedDate).format("LLL") || "N/A"
                    : "N/A"}
                </Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Typography variant="h6">Market Date: </Typography>
                <Typography variant="body1">
                  {moment(presaleOrder.saleDate).format("dddd, LL")}
                </Typography>
              </Box>
            </Box>
            <Divider />
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Typography variant="h6">Pickup Option: </Typography>
              <Typography variant="body1">
                {presaleOrder.pickupLocation?.name}
              </Typography>
            </Box>
            <Divider />
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Typography variant="h6" data-testid="presale-item-count">
                Quantity:{" "}
                {presaleOrder.orderProducts?.reduce(
                  (acc, item) => acc + item.quantity,
                  0
                )}
              </Typography>
            </Box>
            <Divider />
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Typography variant="h6">Estimated Total: </Typography>
              <Typography variant="body1" fontWeight="bold">
                {displayPrice(presaleOrder.total)}
              </Typography>
            </Box>
          </Grid>
          <Grid xs={12} sm={7}>
            <Typography variant="h4">Product in Order</Typography>
            {presaleOrder.orderProducts.length > 0 &&
              presaleOrder.orderProducts.map((product, index) => (
                <ProductInstanceSummary
                  key={product.presaleOrderItemId + "-" + product.quantity}
                  productInstance={product}
                  summaryComponents={[
                    ProductQuantityChip,
                    ({ product }) => (
                      <Typography sx={{ mr: 1 }}>
                        {displayPrice(product.unitPrice)}
                      </Typography>
                    ),
                    ({ product }) => (
                      <Typography sx={{ ml: 2 }} fontWeight="bold">
                        {displayPrice(product.unitPrice * product.quantity)}
                      </Typography>
                    ),
                  ]}
                />
              ))}
          </Grid>
        </Grid>
      )}
    </Container>
  );
}
